// extracted by mini-css-extract-plugin
export var loader = "Loader-module--loader--b2431";
export var rotation = "Loader-module--rotation--c02d6";